import { ChangeDetectorRef, Component, OnInit } from '@angular/core'
import { Router } from '@angular/router'
import { Actions, ofType } from '@ngrx/effects'
import { Store } from '@ngrx/store'
import {
  AuthService,
  CurrencyService,
  GlobalMessageType,
  GlobalMessageService,
  SiteContextActions,
} from '@spartacus/core'
import { UserAccountFacade } from '@spartacus/user/account/root'
import { Observable, of } from 'rxjs'
import { switchMap, take } from 'rxjs/operators'
import { ChangeCustAccountService } from '../change-cust-account/change-cust-account.service'
import { MultiCartFacade } from '@spartacus/cart/base/root'
import { OccCartAdapter } from '@spartacus/cart/base/occ'
import { CommonService } from '../../../shared/services/common.service'

@Component({
  standalone: false,
  selector: 'vs-customer-account-details',
  templateUrl: './customer-account.component.html',
  styleUrls: ['./customer-account.component.scss'],
})
export class CustomerAccountDetailsComponent implements OnInit {
  user$: Observable<any>
  public showSideNav: boolean = false
  width: boolean = false
  isLggedIn: boolean = false
  displayChangeAccount: boolean = false
  customerCurrency: any = ''
  changeUrl

  constructor(
    private auth: AuthService,
    private commonService: CommonService,
    private userAccountFacade: UserAccountFacade,
    private currencyService: CurrencyService,
    private changeCustAccountService: ChangeCustAccountService,
    private changeDetection: ChangeDetectorRef,
    private globalMessageService: GlobalMessageService,
    private multiCartFacade: MultiCartFacade,
    private occAdapter: OccCartAdapter,
    private actions$: Actions,
    private router: Router,
    protected store: Store<any>
  ) {
    this.changeCustAccountService.changeLegalEntityEmitted$.subscribe(
      (res) => {
        if (res) {
          this.user$ = this.userAccountFacade.get()
          // this.occAdapter.create('current').pipe(take(1)).subscribe((occData) => {
          //   this.multiCartService.loadCart({
          //     userId: 'current',
          //     cartId: occData.code,
          //     extraData: {
          //       active: true,
          //     },
          //   });
          //   this.actions$.pipe(ofType(CartActions.LOAD_CART_SUCCESS), take(1)).subscribe((success) => {
          //     window.location.reload();
          //   });
          // });
        }
      },
      (error) => {
        this.globalMessageService.add(
          error,
          GlobalMessageType.MSG_TYPE_ERROR,
          5000
        )
        window.scrollTo(0, 0)
      }
    )
  }

  ngOnInit(): void {
    this.user$ = this.auth.isUserLoggedIn().pipe(
      switchMap((isUserLoggedIn) => {
        if (isUserLoggedIn) {
          if (!this.isLggedIn) {
            this.isLggedIn = true
            this.checkLegalEntitiesAndCustomerAccounts()
          }
          return this.userAccountFacade.get()
        } else {
          return of(undefined)
        }
      })
    )
    /*this.user$.subscribe((res) => {
       if (res?.recentSalesArea?.currency?.isocode) {
         this.currencyService.setActive(res.recentSalesArea.currency.isocode);
       }
     }, (error) => {
       this.globalMessageService.add(
         error,
         GlobalMessageType.MSG_TYPE_ERROR,
         5000
       );
       window.scrollTo(0, 0);
     });*/
    this.router.events.subscribe((event) => {
      this.changeUrl = event
      if (this.router.url != this.changeUrl.url) {
        this.showSideNav = false
      }
    })

    this.commonService.closeMenu.subscribe((menuStatus) => {
      if (menuStatus.changeAccMenu) {
        this.showSideNav = true
        this.changeDetection.detectChanges()
      } else {
        this.showSideNav = false
        this.changeDetection.detectChanges()
      }
    })
  }

  openDetail() {
    this.showSideNav = true
    this.width = true
    this.commonService.closeMenu.next({
      profileMenu: false,
      miniCart: false,
      megaNavMenu: false,
      changeAccMenu: true,
    })
  }
  closeSideNav(event) {
    this.showSideNav = event
  }

  checkLegalEntitiesAndCustomerAccounts() {
    //Make an API call to check if the user have multiple Customer Accounts
    this.changeCustAccountService.getCustomerAccDetails().subscribe(
      (response) => {
        if (response !== null && response !== undefined) {
          if (response['b2bUnits'] !== undefined) {
            if (response['b2bUnits'].length > 0) {
              response['b2bUnits']?.forEach((unit) => {
                if (unit.isDefaultB2bUnit) {
                  this.currencyService.setActive(unit?.currency?.isocode)
                  this.customerCurrency = unit.currency
                  this.store.dispatch(
                    new SiteContextActions.SetActiveCurrency(
                      unit?.currency?.isocode
                    )
                  )
                }
              })
              // if (!this.customerCurrency) {
              //   this.currencyService.setActive('USD');
              //   this.customerCurrency = {
              //     isocode: 'USD',
              //     symbol: '$'
              //   };
              // }
            }
            if (response['b2bUnits'].length > 1) {
              //display Change Account dropdown only if there are more than 1, b2bunits
              this.displayChangeAccount = true
              this.changeDetection.detectChanges()
            } else {
              //else
              //Make an API call to fetch the legal entities
              this.changeCustAccountService
                .getLegalEntities(response['b2bUnits'][0].uid)
                .subscribe(
                  (data) => {
                    if (data !== null && data !== undefined) {
                      if (
                        data['vsSalesArea'] !== undefined &&
                        data['vsSalesArea'].length > 1
                      ) {
                        //display Change Account dropdown only if there are more than 1, legal entities
                        this.displayChangeAccount = true
                      } else {
                        this.displayChangeAccount = false
                      }
                    } else {
                      this.displayChangeAccount = false
                    }
                    this.changeDetection.detectChanges()
                  },
                  (error) => {
                    /* this.globalMessageService.add(
                    error,
                    GlobalMessageType.MSG_TYPE_ERROR,
                    5000
                  );
                  window.scrollTo(0, 0); */
                  }
                )
            }
          } else {
            this.displayChangeAccount = false
          }
        } else {
          this.displayChangeAccount = false
        }
        this.changeDetection.detectChanges()
      },
      (error) => {
        /* this.globalMessageService.add(
          error,
          GlobalMessageType.MSG_TYPE_ERROR,
          5000
        );
        window.scrollTo(0, 0); */
      }
    )
  }
}
